// extracted by mini-css-extract-plugin
export default {"pack":"Pack_pack__9Km0y","imageContainer":"Pack_imageContainer__HmpyI","caption":"Pack_caption__l2g8h"};